import type { ReactNode } from 'react';
import { useLingui } from '@lingui/react/macro';
import { FormOptionalLabelProvider } from '@worldcoo/ui/components/form/form-optional-label';

export function FormTranslationsProvider({ children }: { children: ReactNode }) {
	const { t } = useLingui();
	return <FormOptionalLabelProvider value={t`Optional`}>{children}</FormOptionalLabelProvider>;
}
